<template>
  <div id="users_list">
    <b-card>
      <highcharts :options="chartOptions"></highcharts>
      <v-server-table ref="serverTable" :columns="columns" :options="options">
        <div slot="beforeTable" v-if="selected && selected.length > 0" class="m-1">
          Выбрано: {{ selected.length }}. <b-btn size="sm">Отправить сообщение</b-btn>
        </div>
        <div slot="filter__selected" class="text-center">
          <b-form-checkbox @change="selectAll($event)" size="lg" />
        </div>
        <span slot="selected" slot-scope="props" class="text-center">
          <b-form-checkbox v-model="selected" :value="props.row.user_id" />
        </span>
        <div slot="child_row" slot-scope="props">
          <crmTasks :moderators="managers" :tasks="props.row.crmTasks" :user_id="props.row.user_id"></crmTasks>
        </div>
        <span slot="countTasks" slot-scope="props" class="text-center">
          {{ props.row.crmTasks.length }}
        </span>
        <span slot="name" slot-scope="props" class="text-center">
          <h4><b-badge variant="success" size="xl" v-if="props.row.partner == 'mst'">МСТ</b-badge></h4>

          {{ props.row.last_name }} <br />{{ props.row.name }} <br />{{ props.row.second_name }}
        </span>
        <span slot="email" slot-scope="props" class="text-center">
          Email: {{ props.row.user.email }}<br />
          Телефон: {{ props.row.user.phone }} <br />
        </span>
        <span slot="crmManagers" slot-scope="props" class="text-center">
          <selectManagers
            :managers="managers"
            :selected="props.row.crmManagers"
            :user_id="props.row.user_id"
          ></selectManagers>
        </span>

        <span slot="countProjects" slot-scope="props" class="text-center">
          {{ Object.keys(props.row.projects).length }}
          <a
            href="javascript: void(0)"
            @click="
              cur_projects = props.row.projects;
              $refs.projects.show();
            "
            class="m-1"
            ><i class="fa fa-eye"></i
          ></a>
        </span>
        <span slot="countCalculated" slot-scope="props" class="text-center">
          {{ props.row.projects.filter((project) => project.status == 2).length }}
        </span>
        <span slot="licenses" slot-scope="props" class="text-center">
          <div v-if="props.row.licenses.length > 0">
            <div v-for="(license, key) in props.row.licenses" :key="license.activated_at">
              {{ key + 1 }}.
              <span
                class="text-success"
                v-if="parseInt(license.time) + parseInt(license.activated_at) > parseInt(new Date().getTime() / 1000)"
                >Активна до
                {{
                  (parseInt(license.time) + parseInt(license.activated_at))
                    | moment("timezone", $moment.tz.guess(), "lll")
                }}</span
              >
              <span class="text-danger" v-else
                >Истекла
                {{
                  (parseInt(license.time) + parseInt(license.activated_at))
                    | moment("timezone", $moment.tz.guess(), "lll")
                }}
              </span>
              <span v-if="license.package_id == 0">(Демо)</span>
              <span v-if="license.partner == 'mst'">(Создана MST)</span>
            </div>
          </div>
          <div v-else>Лицензии отсутствуют</div>
        </span>
        <span slot="actions" slot-scope="props">
          <center>
            <a href="javascript: void(0)" @click="userEdit(props.row)" class="m-1"><i class="fa fa-2x fa-cog"></i></a>
            <a @click="login(props.row.user_id)" href="#" class="m-1"><i class="fa fa-2x fa-user-secret"></i></a>
          </center>
        </span>
        <span slot="confirmed" slot-scope="props">
          <center>
            <h6>
              <span v-if="props.row.user.confirmed_at"
                ><b-badge variant="success"
                  >Подтвержден<br />
                  {{ props.row.user.confirmed_at | moment("d/MM/YYYY, H:mm:ss") }}</b-badge
                ></span
              >
              <span v-else
                ><b-badge variant="danger"
                  ><i>не подтвержден</i><br /><b-btn
                    size="sm"
                    class="m-1"
                    @click="confirm(props.row.user_id, props.index)"
                    >Подтвердить</b-btn
                  ></b-badge
                >
              </span>

              <b-badge variant="danger" class="m-1" v-if="props.row.user.blocked_at"
                ><i>Заблокирован</i>
                <a href="javascript: void(0)" class="m-1" @click="lock(props.row.user_id, props.index)">
                  <i class="fa fa-unlock-alt fa-2x text-success"></i> </a
              ></b-badge>
            </h6>
            <a
              v-if="!props.row.user.blocked_at"
              href="javascript: void(0)"
              class="m-1"
              @click="lock(props.row.user_id, props.index)"
            >
              <i class="fa fa-lock fa-2x text-danger"></i>
            </a>
            <a
              href="javascript: void(0)"
              v-on:click.prevent="
                $refs.remove_modal.index = props.index;
                $refs.remove_modal.user_id = props.row.user_id;
              "
              v-b-modal.remove_modal
              class="m-1"
              ><i class="fa fa-2x fa-trash"></i
            ></a>
          </center>
        </span>
      </v-server-table>
    </b-card>
    <b-modal id="projects" ref="projects" title="Проекты пользователя" hide-footer>
      <template v-if="cur_projects">
        <div v-for="(project, index) in cur_projects" class="m-0 p-0" :key="project.id">
          {{ index + 1 }}.
          <router-link :to="'/risk/' + project.id" class="m-0 p-0">
            {{ project.name }}
            <b-badge v-if="project.status == 0" class="m-0">Не рассчитан</b-badge>
            <b-badge v-if="project.status == 1" variant="primary" class="m-0">В процессе расчета</b-badge>
            <b-badge v-if="project.status == 3" variant="danger" class="m-0">Возникли ошибки</b-badge>
            <b-badge v-if="project.status == 2" variant="success" class="m-0">Рассчитан</b-badge>
            <b-badge v-if="project.status == 4" variant="warning" class="m-0"
              >Ограничено рассчитан</b-badge
            ></router-link
          >
        </div>
      </template>
    </b-modal>
    <b-modal id="settings" ref="settings" title="Настройки пользователя" size="xl" hide-footer>
      <settings
        v-if="currentUser && currentUser.user_id"
        @update="currentUser = $event"
        :user_id="currentUser.user_id"
      ></settings>
    </b-modal>
    <b-modal ref="remove_modal" hide-footer id="remove_modal" title="Удаление">
      <div class="d-block text-center">
        <h3>Вы действительно хотите удалить этого пользователя? Это действие необратимо.</h3>
      </div>
      <b-btn
        class="mt-3 btn-outline"
        variant="danger"
        block
        @click="
          remove($refs.remove_modal.user_id, $refs.remove_modal.index);
          $refs.remove_modal.hide();
        "
        >Удалить
      </b-btn>
    </b-modal>
  </div>
</template>
<style>
.VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

.VueTables__child-row-toggler--closed::before {
  content: "+";
}

.VueTables__child-row-toggler--open::before {
  content: "-";
}
</style>
<script>
import "vue-multiselect/dist/vue-multiselect.min.css";
import settings from "../user/settings";
import selectManagers from "./selectManagers";
import { Chart } from "highcharts-vue";
import crmTasks from "./crmTasks";
export default {
  name: "users_list",
  components: {
    settings,
    selectManagers,
    highcharts: Chart,
    crmTasks,
  },

  data() {
    return {
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "Распределение зарегистрированных пользователей",
        },
        subtitle: {
          text: "Наши лучшие показатели - довольные покупатели!",
        },
        xAxis: {
          categories: ["Все", "Год", "Квартал", "Месяц"],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Количество",
          },
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Общее количество",
            data: [],
          },
          {
            name: "Приобрели лицензию",
            data: [],
          },
        ],
      },
      cur_projects: [],
      selected: [],
      currentUser: null,
      managers: [],
      filter_activity_area: null,
      filter_activity_direction: null,
      columns: [
        "countTasks",
        "user_id",
        "name",
        "email",
        "crmManagers",
        "countProjects",
        "countCalculated",
        "licenses",
        "confirmed",
        "actions",
      ],
      options: {
        uniqueKey: "user_id",
        headings: {
          selected: "#",
          user_id: "ИД",
          name: "ФИО",
          crmManagers: "Ответственные лица",
          countProjects: "Количество созданных проектов",
          countCalculated: "Количество рассчитаных проектов",
          email: "Контакты",
          licenses: "Лицензии",
          actions: "Действия",
          confirmed: "Доступ",
        },
        skin: "table table-sm table-striped table-bordered table-hover",
        filterByColumn: true,
        filterable: ["user_id", "name", "email", "crmManagers"],
        listColumns: {
          crmManagers: [{ id: 1, text: "Загрузка списка Менеджеров" }],
        },
        sortable: ["user_id", "name"],
        sortIcon: { base: "fa", up: "fa-chevron-up", down: "fa-chevron-down", is: "fa-sort" },
        columnsDropdown: false,
        perPage: 25,
        debounce: 1000,
        perPageValues: [10, 25, 50, 100],
        responseAdapter: function (resp) {
          const newResp = this.getResponseData(resp);
          this.$parent.$parent.managers = newResp.data.managers;
          var managers = [];
          for (var manN of newResp.data.managers) {
            managers.push({ id: manN.user_id, text: manN.name });
          }
          this.$parent.$parent.options.listColumns.crmManagers = managers;
          return { data: newResp.data.profile, count: newResp.data.count };
        },
        requestFunction: function (data) {
          return this.$http
            .post("admin/users/get?page=" + data.page + "&per_page=" + data.limit, {
              query: data.query,
              sort: data.orderBy,
              ascending: data.ascending,
            })
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        },
        texts: {
          count: "Показано с {from} по {to} из {count} записей|{count} записей|Одна запись",
          first: "Начало",
          last: "Конец",
          filter: "Фильтр",
          filterPlaceholder: "Поиск",
          limit: "Записей:",
          page: "Страница:",
          noResults: "Ничего не найдено",
          filterBy: "{column}",
          loading: "Загрузка...",
          defaultOption: "Выбрано {column}",
          columns: "Колонки",
        },
      },
    };
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: "getInfo",
  },
  methods: {
    getChart() {
      this.$http.get("admin/users/statistics").then((response) => {
        // JSON responses are automatically parsed.
        for (var count of response.data.count) {
          this.chartOptions.series[0].data.push(parseInt(count));
        }
        for (var calculated of response.data.calculated) {
          this.chartOptions.series[1].data.push(parseInt(calculated));
        }
      });
    },
    selectAll(e) {
      if (e) {
        this.selected = this.$refs.serverTable.$refs.table.data.map((el) => el.user_id);
      } else {
        this.selected = [];
      }
    },
    getIndex(index) {
      return index - this.$refs.serverTable.$refs.table.limit * (this.$refs.serverTable.$refs.table.page - 1) - 1;
    },
    remove(user_id, index) {
      index = this.getIndex(index);
      this.$http
        .get("admin/users/remove", {
          params: {
            id: user_id,
          },
        })
        .then(() => {
          // JSON responses are automatically parsed.
          this.$refs.serverTable.$refs.table.data.splice(index, 1);
        })
        .catch((e) => {
          alert("Возникла ошибка", e);
        });
    },
    lock(user_id, index) {
      index = this.getIndex(index);
      this.$http
        .get("admin/users/lock", {
          params: {
            id: user_id,
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.$set(this.$refs.serverTable.$refs.table.data[index].user, "blocked_at", response.data);
        })
        .catch((e) => {
          alert("Возникла ошибка", e);
        });
    },
    confirm(user_id, index) {
      index = this.getIndex(index);
      this.$http
        .get("admin/users/confirm", {
          params: {
            id: user_id,
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.$set(this.$refs.serverTable.$refs.table.data[index].user, "confirmed_at", response.data);
        })
        .catch((e) => {
          alert("Возникла ошибка", e);
        });
    },
    userEdit(user) {
      this.currentUser = user;
      this.$refs.settings.show();
    },
    login(user_id) {
      this.$auth
        .login({
          url: "auth/login?user_id=" + user_id,
          redirect: { name: "Index" },
        })
        .then(() => {
          console.log("success " + this.context);
        })
        .catch((e) => {
          this.error = e.response.data;
        });
    },
  },
  created() {
    this.getChart();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.VueTables__limit .form-group {
  width: auto !important;
}
.VueTables__search-field {
  display: flex;
}
.VueTables__limit-field {
  display: flex;
}
</style>
